import React from "react";
import "./Copyright.css";

const Copyright = () => {
  return (
    <div className="copyrightDiv">
      <p className="copyrightText">Created by Sami Samara | &copy; Copyright 2022 Sami Samara</p>
    </div>
  )
}

export default Copyright;